import { Textarea } from '@te-whatu-ora/anatomic'
import type { TextInputProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { ChangeEvent } from 'react'
import { useAdditionalLabelProperties } from '@/components/fhirEngine/utils/additionalProperties'
import { RequiredInputWrapper } from '@/components/fhirEngine/utils/requiredLabel'

export default function TextInput(props: TextInputProps) {
  const {
    inputId,
    onChange,
    error,
    onBlur,
    onFocus,
    value,
    labelComponent,
    required,
    maxLength
  } = props

  function handleChange(event: ChangeEvent<HTMLTextAreaElement>) {
    const newValue = event.target.value

    if (maxLength !== undefined && newValue.length > maxLength) {
      onChange(newValue.slice(0, maxLength) || null)
      return
    }

    onChange(newValue || null)
  }

  const currentLength = value?.length ?? 0
  const characterCount =
    maxLength !== undefined
      ? `Maximum ${maxLength} characters — ${currentLength} used`
      : undefined

  const maxLengthReached =
    maxLength !== undefined && currentLength >= maxLength
      ? `Maximum ${maxLength} characters — ${maxLength} used`
      : undefined

  const displayError = error ?? maxLengthReached
  const displayHelperText = displayError ? undefined : characterCount

  const additionalProps = useAdditionalLabelProperties(props)

  return (
    <RequiredInputWrapper
      inputId={inputId}
      labelComponent={labelComponent}
      required={required}
    >
      <Textarea
        {...additionalProps}
        name={inputId}
        type='text'
        errorMessage={displayError}
        helperText={displayHelperText}
        maxLength={maxLength}
        onBlur={onBlur}
        onChange={handleChange}
        onFocus={onFocus}
        value={value ?? undefined}
      />
    </RequiredInputWrapper>
  )
}
